// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { LocalizedComponentProps, LocalizedText, withLocalization } from '@shared-ui/localization-context';
import { AnalyticsStore, RouteStore } from 'bernie-core';

// ui
import { UitkHeading, UitkSubheading } from 'uitk-react-text';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { BookmarkletLink } from './bookmarklet-link';
import { UitkList, UitkListItem } from 'uitk-react-list';

// stores
import { ProductStore, ProgramStore, UserAuthStore } from 'stores';

// utils
import { getProgramAnalyticsMicroMessage, getProductAnalyticsMicroMessage } from '../../util/analytics';

export interface Props extends LocalizedComponentProps {
  analytics?: AnalyticsStore;
  programs?: ProgramStore;
  products?: ProductStore;
  routeStore?: RouteStore;
  userAuth?: UserAuthStore;
}

@withLocalization
@inject('analytics', 'programs', 'routeStore', 'userAuth', 'products')
export class Bookmarklet extends React.Component<Props> {
  public constructor(props) {
    super(props);
  }

  public componentDidMount() {
    setTimeout(() => {
      const { analytics, programs, routeStore, userAuth, products } = this.props;

      const programName = routeStore.queryParams.programName;
      const program = programs.getProgram(programName);
      const product = products.getProduct(programName, 'bookmarklet');
      const programStatus = this.getProgramStatus(program, userAuth);

      if (typeof analytics?.trackEvent === 'function') {
        analytics.trackEvent('affhub.product_config', 'AffHub Product Config Presented', null, null, true, [
          getProgramAnalyticsMicroMessage(program, programStatus),
          getProductAnalyticsMicroMessage(product),
        ]);
      }
    }, 3500);
  }

  private getProgramStatus(program, userAuth) {
    let programStatus = null;
    const currentUser = userAuth.currentUser;
    const userId = currentUser && currentUser.email ? currentUser.email : null;

    if (userId) {
      const userProgram = userAuth.userProgramRelationships
        ? userAuth.userProgramRelationships.body.filter((userProg) => {
            return (
              userProg.id.userId === userId && userProg.id.brand === program.brand && userProg.id.posa === program.posa
            );
          })
        : [];

      if (userProgram.length) {
        programStatus = userProgram[0].affiliatePartnership.partnershipStatus;
      }
    }

    return programStatus;
  }

  public render() {
    const { l10n } = this.props;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkSubheading>
            <LocalizedText message="bookmarklet.subheader" />
          </UitkSubheading>
          <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
            <UitkList type="ordered">
              <UitkListItem key="listitem-1-1">
                <LocalizedText message="bookmarklet.step1" />
              </UitkListItem>
              <UitkListItem key="listitem-1-2">
                <LocalizedText message="bookmarklet.step2" />
              </UitkListItem>
              <UitkListItem key="listitem-1-3">
                <LocalizedText message="bookmarklet.step3" />
                <UitkSpacing padding={{ block: 'three' }}>
                  <div>
                    <BookmarkletLink>
                      <UitkPrimaryButton>{l10n.formatText('bookmarklet.button.label')}</UitkPrimaryButton>
                    </BookmarkletLink>
                  </div>
                </UitkSpacing>
              </UitkListItem>
              <UitkListItem>
                <LocalizedText message="bookmarklet.step4" />
              </UitkListItem>
              <UitkListItem>
                <LocalizedText message="bookmarklet.step5" />
              </UitkListItem>
            </UitkList>
          </UitkSpacing>
        </main>
      </UitkSpacing>
    );
  }
}
